Namespace 'CustomerVisualMode.Filters'

CustomerVisualMode.Filters.HierarchicalTagsFilterMixin =
  attributeCode: ->
    @filter.getCode()

  openHierarchicalTagsFilterModal: ->
    @hierarchicalTagsFilterView?.remove()
    @hierarchicalTagsFilterView = new CustomerVisualMode.Filters.SingleFilters.HierarchicalTagsFilterView(
      values: @filter.getAttribute().get('hierarchical_tags').tags
      placeholder: I18n.t 'common.session.filters.hierarchical_tags.modal.placeholder'
      title: @modalTitle()
      selectedOptions: @filter.getValues().map (value) -> value.code
    ).render()
    @listenTo(@hierarchicalTagsFilterView, 'filters:multiplevalues:apply', @triggerFilterApplied)

  triggerFilterApplied: ->
    @trigger('filter:apply', @hierarchicalTagsFilterView.getSelectedValues())
